import { Block, InlineBlock } from '@components/Layout/Blocks';
import { Row, RowProps } from '@components/Layout/Row';
import Typography from '@material-ui/core/Typography';
import { IF } from '@packages/react/lib/if';
import { renderChildren } from '@packages/react/lib/renderChildren';
import React, { ComponentType, ReactElement } from 'react';

interface HeaderProps extends RowProps {
    headline?: string | ReactElement | ComponentType<any> | null;
    subHeadline?: string | ReactElement | ComponentType<any> | null;
}

export function Headline(props: HeaderProps): ReactElement {
    const { headline, subHeadline, ...rest } = props;

    const headline$: any =
        typeof headline === 'string' ? (
            <Typography variant={'h5'}>{headline}</Typography>
        ) : (
            renderChildren(headline as any)
        );

    const subHeadline$: any =
        typeof subHeadline === 'string' ? (
            <Typography variant={'subtitle1'} color={'textSecondary'}>
                {subHeadline}
            </Typography>
        ) : (
            renderChildren(subHeadline as any)
        );

    return (
        <Row layout={'column'} align={'start'} justify={'center'} padding={24} {...rest}>
            <InlineBlock p={'0 0 0 8px'}>
                {IF(headline$, <Block>{headline$}</Block>)}
                {IF(subHeadline$, <Block p={'6px 0 0 0'}>{subHeadline$}</Block>)}
            </InlineBlock>
        </Row>
    );
}

Headline.displayName = 'Headline';
Headline.defaultProps = {
    headline: null,
    subHeadline: null,
};
